<template lang='pug'>
  div.noflex(style="flex: none; min-width:0; width:#{v.width}px;" :title="v.title?v.title:v.label")
    div
      popover.a.row-title(ref='colPo' :width=245)
        | 列：{{v.label}} &nbsp;&nbsp;&nbsp;
        span.right
          popover(ref="dupChart" text="查重" :width="300")
            dup(:opts="pie_opts")
          popover(ref="pieChart" text="饼图" :width="600")
            pie(:opts="pie_opts")
          popover(ref="filtChart" text="筛选" :width="600")
            filt(:opts="pie_opts")
        hr
        div(style="margin:10px 0;")
          span(style="margin-right:10px;") 排序：
          el-button(@click="sort(false)" size="mini" )
            i.el-icon-caret-top.sort 升序
          el-button(@click="sort(true)" size="mini" )
            i.el-icon-caret-bottom.sort 降序
        div
          span 空行筛选：
          el-button(@click="filterNull(v.label)" size="mini") 空
          el-button(@click="filterNotNull(v.label)" size="mini") 非空
        div(style="margin-top:5px;") 按条件筛选：
        div.filter-box
          select(v-if="v.type=='select'"
            ref='filter'
            v-model="content")
            option(label="--" value="")
            template(v-for="(val, key) in v.options")
              option {{val}}
          input.filter(v-else
            ref='filter'
            v-model.lazy="content"
            placeholder="或:xx/xx 非:@xx")
          el-button(@click="doSearch(v.label)" size="mini") 查找
          el-button(@click="doFilter(v.label)" size="mini") 筛选
        popover.batchedit(v-if="v.batchEditable" @confirm="batchEdit" :showConfirm="true" btnText="批量修改")
          span(slot='trigger')
            el-button(size="mini") 批量修改
          el-checkbox-group(v-if="v.type=='multiple'" v-model="batchArr" ref="batch")
            div(v-for="(val, k) in v.options")
              el-checkbox(:label="k")
          el-autocomplete(
            v-else-if="v.type=='autocomplete'"
            ref="batch"
            v-model="batch"
            :fetch-suggestions="fetchSuggestions")
          div(v-else-if="v.type=='spreadsheet'")
            div 点击--选择后确认 并点击＂批量修改＂
            cell( ref="batchEditCell"
                  mode="body"
                  :opts="opts"
                  :shownColumns="shownColumns"
                  :row="0"
                  :col="col"
                  :rowObj="rowObj"
                  )
          div(v-else)
            el-input(v-model="batch" size="mini")
        div(slot='trigger') {{v.displayLabel || v.label}}

</template>

<script>
// Generated by CoffeeScript 2.3.0
var cell, dup, filt, m, pie, suggestions;

suggestions = {};

pie = require('./charts/pie');

dup = require('./charts/dup');

filt = require('./charts/filt');

cell = require('./cell');

export default m = {
  components: {pie, dup, filt, cell},
  props: {
    opts: Object,
    col: Number,
    filterby: Object,
    v: Object,
    shownColumns: Array
  },
  data: function() {
    return {
      content: '',
      batch: '',
      batchArr: [],
      rowObj: {
        [`${this.v.label}`]: ''
      },
      pie_opts: {
        title: `${this.opts.displayName}-${this.v.label}`,
        load: () => {
          return app.api.analyze({
            tableName: this.opts.tableName,
            label: this.v.label,
            query: this.$parent.query()
          });
        },
        // ids = @$parent.data.map (item) => item._id
        // app.api.find
        //   tableName: @opts.tableName
        //   query:
        //     _id: $in: ids
        //   fields:
        //     "#{@v.label}": 1
        // .then (data) =>
        //   data.map (item) => item[@v.label]
        click: (value) => {
          return this.$parent.filter({
            [`${this.v.label}`]: value
          });
        },
        clickOnNull: () => {
          return this.filterNull(this.v.label);
        }
      }
    };
  },
  methods: {
    doFilter: function() {
      var tmp;
      tmp = this.$parent.filterby;
      tmp[this.v.label] = this.content;
      this.$parent.filterby = tmp;
      if (this.opts.filterCacheable) {
        app.config.save();
      }
      this.$emit('filter');
      return this.$refs.colPo.close();
    },
    doSearch: function() {
      this.$emit('search', this.col, this.content);
      return this.$refs.colPo.close();
    },
    sort: function(reverse) {
      return this.$emit('sort', this.v.label, reverse);
    },
    filterNotNull: function() {
      var tmp;
      tmp = this.$parent.filterby;
      tmp[this.v.label] = '$notnull';
      this.$parent.filterby = tmp;
      if (this.opts.filterCacheable) {
        app.config.save();
      }
      this.$emit('filter');
      return this.$refs.colPo.close();
    },
    filterNull: function() {
      var tmp;
      tmp = this.$parent.filterby;
      tmp[this.v.label] = '$null';
      this.$parent.filterby = tmp;
      if (this.opts.filterCacheable) {
        app.config.save();
      }
      this.$emit('filter');
      return this.$refs.colPo.close();
    },
    cellStyle: function(v) {
      var style;
      style = '';
      if (v.width) {
        style = `flex: none; min-width:0; width:${v.width}px;`;
      }
      return style;
    },
    batchEdit: function() {
      var batch, data, ids;
      batch = this.batch;
      if (this.batchArr.length > 0) {
        batch = this.batchArr.map((i) => {
          return this.v.options[i];
        }).join(';');
        this.batchArr = [];
      } else if (this.v.type === 'spreadsheet') {
        batch = this.$refs.batchEditCell.content;
      }
      ids = [];
      this.$parent.forEachChecked((item) => {
        item[this.v.label] = batch;
        return ids.push(item._id);
      });
      data = {};
      data[this.v.label] = batch;
      if (this.v.handlebatchEdit) {
        return this.v.handlebatchEdit(ids, data).then(() => {
          return this.$parent.cancelChecked();
        });
      } else {
        return app.api.updateMultiple({
          tableName: this.opts.tableName,
          ids: ids,
          data: data
        }).then(() => {
          this.$parent.cancelChecked();
          return ids.forEach((id) => {
            return this.$parent.updateRowById(id, [this.v.label]);
          });
        });
      }
    },
    fetchSuggestions: function(qs, cb) {
      var key, s;
      key = this.v.tableName + '-' + this.v.label;
      s = [];
      return Promise.resolve().then(() => {
        if (suggestions[key]) {
          return s = suggestions[key];
        } else if (this.v.options) {
          return s = suggestions[key] = this.v.options.map((item) => {
            return {
              value: item
            };
          });
        } else {
          return app.api.find({
            tableName: this.v.tableName
          }).then((list) => {
            return s = suggestions[key] = list.map((item) => {
              return {
                value: item[this.v.field]
              };
            });
          });
        }
      }).then(() => {
        return cb(s.filter((c) => {
          return c.value && c.value.indexOf(qs) !== -1;
        }));
      });
    }
  }
};
</script>


